import { z } from 'zod';

export const TenantBaseModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  code: z.string().min(1),
  name: z.string().min(1),
  logoUrl: z.string().url(),
  iconUrl: z.string().url(),
  faviconUrl: z.string().url(),
});
